export default __webpack_public_path__ + "static/media/ticker_vs_req01.2289af9c.svg";